import "/src/styles/main.scss"
import AOS from 'aos';

// Other
import "./helpers"


AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
    once: false,
    // disable: function() {
    //     let maxWidth = 800;
    //     return window.innerWidth < maxWidth;
    // }
});

// Modules
// import MouseLine from "./modules/animation-mouse-line";
// MouseLine().init()

// import AnimationFooter from "./modules/animation-footer";
// AnimationFooter().init()

import AnimationMagnetic from "./modules/animation-magnetic";
AnimationMagnetic().init()

import AnimationSlideUp from "./modules/animation-slide-up";
AnimationSlideUp().init()

import AnimationText from "./modules/animation-text";
AnimationText().init()

import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNavMobile from "./modules/site-nav-mobile";
SiteNavMobile().init()

import SearchOverlay from "./modules/search-overlay";
SearchOverlay().init()

import SmoothAnchor from "./modules/smooth-anchor";
SmoothAnchor().init()

import AnimationShape from "./modules/animation-shape";
AnimationShape().init()

import VideoIframe from "./modules/video-iframe";
VideoIframe().init()

import QA from "./modules/qa";
QA().init()

// Templates

// Template parts